import React, { createContext, useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';
import AgeVerificationModal from "../components/AgeVerificationModal/AgeVerificationModal";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [edadVerificada, setEdadVerificada] = useState(false);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      const storedToken = localStorage.getItem('token');
      const storedEdadVerificada = localStorage.getItem('edadVerificada');

      if (storedEdadVerificada === "true") {
        setEdadVerificada(true);
      }

      if (storedUser && storedToken) {
        const parsedUser = JSON.parse(storedUser);

        if (!parsedUser.rol) {
          console.error('El usuario no tiene un rol definido.');
        }

        setUser(parsedUser);
        setToken(storedToken);
      }
    } catch (error) {
      console.error('Error al inicializar datos del localStorage:', error);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000;

      if (decoded.exp < now) {
        Swal.fire({
          icon: 'warning',
          title: 'Sesion expirada',
          text: 'Por seguridad, tu sesion ha finalizado. Inicia sesion nuevamente.',
          confirmButtonText: 'Ir al login'
        }).then(() => {
          logout();
          window.location.href = '/login-admin';
        });
      } else {
        const tiempoRestante = (decoded.exp - now) * 1000;
        const timeout = setTimeout(() => {
          Swal.fire({
            icon: 'warning',
            title: 'Sesion expirada',
            text: 'Por seguridad, tu sesion ha finalizado. Inicia sesion nuevamente.',
            confirmButtonText: 'Ir al login'
          }).then(() => {
            logout();
            window.location.href = '/login-admin';
          });
        }, tiempoRestante);

        return () => clearTimeout(timeout);
      }
    } catch (err) {
      console.error('Token invalido o error al decodificar:', err);
      logout();
      window.location.href = '/login-admin';
    }
  }, [token]);

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', authToken);
  };

  const logout = () => {
    setUser(null);
    setToken(null);

    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const confirmarEdad = () => {
    setEdadVerificada(true);
    localStorage.setItem('edadVerificada', "true");
  };

  const negarAcceso = () => {
    setEdadVerificada(false);
    alert("Debes ser mayor de 18 anos para ingresar.");
    window.location.href = "https://www.google.com";
  };

  if (loading) return <div>Cargando...</div>;

  return (
    <UserContext.Provider
      value={{
        user,
        token,
        edadVerificada,
        confirmarEdad,
        negarAcceso,
        login,
        logout,
      }}
    >
      {!edadVerificada && <AgeVerificationModal />}
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
